import script from "./UserProfilePlugins.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfilePlugins.vue?vue&type=script&setup=true&lang=js"

import "./UserProfilePlugins.vue?vue&type=style&index=0&id=52804ab9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52804ab9"]])

export default __exports__